<template>
  <div class="not-found">
    <div class="number">
      404
    </div>
    <div class="info">
      <h3>抱歉，页面未找到！</h3>
      <p>服务器很努力，但页面好像搬家了.... <a href="/"><br> 返回首页</a>或留下您的联系方式. </p>
      <div>
        <input type="text" placeholder="...">
        <button>发送</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>

<style scoped>
  .not-found {
    margin: 10px 0;
    /* 让inline-block子盒子居中 */
    text-align: center;
  }

  .number {
    display: inline-block;
    font-size: 158px;
    font-weight: 300;
    text-align: center;
    color: #7bbbd6;
  }

  .info {
    display: inline-block;
    margin-left: 30px;
    text-align: left;
  }

  .info h3 {
    margin: 10px 0;
  }
</style>
